import type { Class } from '@/state/class-groups';

type MinSpotsSource = Pick<
  Class,
  'use_min_spots_per_booking' | 'min_spots_per_booking'
>;

export const getMinSpotsPerBooking = (classData: MinSpotsSource): number =>
  classData.use_min_spots_per_booking && classData.min_spots_per_booking
    ? classData.min_spots_per_booking
    : 1;

export const buildMinSpotsNotice = (minSpots: number) =>
  `This class needs at least ${minSpots} spots.`;

export const buildOneSpotConflictNotice = (
  source: 'pack' | 'subscription',
  minSpots: number
) =>
  `This ${source} allows 1 spot per class, and this class needs at least ${minSpots} spots. Pay another way or pick a different class.`;

export const buildMinSpotsTooltip = (minSpots: number) =>
  `This class needs at least ${minSpots} spots`;

export const buildMinSpotsAllNotice = (
  minSpots: number,
  activeQuantity: number,
  action: 'canceled' | 'moved'
) =>
  `This class needs at least ${minSpots} spots per booking, so all ${activeQuantity} spots will be ${action}.`;
